import { render } from "./TheLoading.vue?vue&type=template&id=38a2eeff&scoped=true"
import script from "./TheLoading.vue?vue&type=script&lang=js"
export * from "./TheLoading.vue?vue&type=script&lang=js"

import "./TheLoading.vue?vue&type=style&index=0&id=38a2eeff&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a2eeff"]])

export default __exports__